import { create } from 'zustand';
import type { SessionSnapshotView } from '@/ride/session';

export type StageView = '3d' | 'workout';

interface RideStoreState {
  view: SessionSnapshotView | null;
  stage: StageView;
  setView: (v: SessionSnapshotView | null) => void;
  setStage: (s: StageView) => void;
}

/** UI-facing ride state, refreshed at ~10 Hz from the session (the 3D world reads the session directly). */
export const useRide = create<RideStoreState>((set) => ({
  view: null,
  stage: '3d',
  setView: (view) => set({ view }),
  setStage: (stage) => set({ stage }),
}));
